{
  "repairCenterNotFoundError": "Aucune configuration de centre de réparation ne correspond à ce dossier.",
  "tooManyRepairCenterFoundError": "Plusieurs configurations de centre de réparation correspondent à ce dossier. Contactez un administrateur.",
  "smsServiceUnavailableError": "Les notifications SMS sont indisponibles. Veuillez réessayer plus tard ou choisir un autre moyen de notification.",
  "smsNotificationFailedError": "Le SMS n'a pas pu être envoyé. Veuillez réessayer.",
  "accountNotFoundError": "Compte introuvable",
  "expiredJwtError": "Session expirée",
  "expiredLogin2faCodeError": "Code de vérification expiré",
  "invalidAccountError": "Compte invalide",
  "invalidBodyError": "Requête invalide",
  "invalidCaptchaTokenError": "Captcha invalide",
  "invalidCsrfError": "Session invalide",
  "invalidEmailError": "Email invalide",
  "invalidJwtError": "Session invalide",
  "invalidLogin2faCodeError": "Code de vérification invalide",
  "invalidNetworkError": "Réseau invalide",
  "invalidNewConfirmPasswordError": "Les mots de passe doivent être identiques",
  "invalidPasswordError": "Mot de passe invalide",
  "invalidPhoneNumberError": "Numéro de téléphone invalide",
  "invalidFirstnameError": "Prénom invalide",
  "invalidLastnameError": "Nom invalide",
  "invalidJobDescriptionError": "Fonction invalide",
  "invalidIdError": "Identifiant invalide",
  "invalidStatusError": "Statut invalide",
  "invalidTokenError": "Jeton invalide",
  "login2faAttemptLimitReachedError": "Nombre de tentatives atteint",
  "login2faRequiredError": "Vérification en deux étapes requise",
  "login2faResendLimitReachedError": "Nombre de renvois atteint",
  "requestDraftNotEditableError": "Cette demande a déjà été soumise et ne peut plus être modifiée.",
  "unexpectedError": "Erreur inattendue",
  "userAlreadyExistsError": "Ce collaborateur existe déjà",
  "collaboratorNotFoundError": "Collaborateur introuvable",
  "unknown": "Erreur inattendue"
}
